import React from 'react';
import colors from '@constants/Colors';

const DiamondIcon = ({ active = true }) => {
  const iconColors = active
    ? [colors.periwinkleStrong, '#E1BBFF']
    : [colors.bluishGrey, colors.cloudyBlue];

  return (
    <svg
      width="18px"
      height="13px"
      viewBox="0 0 18 13"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Explorations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="desktop/creditos/resultado-cotacao" transform="translate(-200.000000, -386.000000)">
          <g id="Group-6" transform="translate(200.000000, 384.000000)">
            <g id="Rectangle-Copy-2" transform="translate(0.000000, 2.000000)">
              <path
                d="M13.4857186,0 L17.4852814,4 L9,12.4852814 L0.514718626,4 L4.51471863,0 L13.4857186,0 Z"
                id="Combined-Shape"
                fill={iconColors[0]}
              />
              <polygon
                id="Rectangle"
                fill={iconColors[1]}
                points="0.514718626 4 9 4 9 12.4852814"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DiamondIcon;
